import { initHeader } from './header.js';
import { initMobileMenu } from './mobileMenu.js';
import { initLangSwitch } from './langSwitch.js';
import { initBannerWithFilter } from './bannerWithFilter.js';
import { initHorizontalScrolling } from './horizontalScrolling.js';
import { initStickyContact } from './stickyContact.js';
import { initAnsprechpartner } from './ansprechpartner.js';
import { initDownloads } from './downloads.js';
import { initLpSlider } from './lpSlider.js';
import { initLpMaterialSlider } from './lpMaterialSlider.js';
import { initLpSurfaceSplit } from './lpSurfaceSplit.js';
import { initProductHotspots } from './productHotspots.js';
import { initProductHotspotsEditor } from './productHotspotsEditor.js';
import { initPricelistPreview } from './pricelistPreview.js';
import { initPricelistFilesize } from './pricelistFilesize.js';
import { initThemeSwitch } from './themeSwitch.js';
import { initIconRowVideo } from './iconRowVideo.js';
import { initInsights } from './insights.js';
import { initInsightsRelated } from './insightsRelated.js';
import { initProduktserienModal } from './produktserienModal.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initMobileMenu();
    initLangSwitch();
    initBannerWithFilter();
    initHorizontalScrolling();
    initStickyContact();
    initAnsprechpartner();
    initDownloads();
    initLpSlider();
    initLpMaterialSlider();
    initLpSurfaceSplit();
    initProductHotspots();
    initProductHotspotsEditor();
    initPricelistPreview();
    initPricelistFilesize();
    initThemeSwitch();
    initIconRowVideo();
    initInsights();
    initInsightsRelated();
    initProduktserienModal();
  });
} else {
  initHeader();
  initMobileMenu();
  initLangSwitch();
  initBannerWithFilter();
  initHorizontalScrolling();
  initStickyContact();
  initAnsprechpartner();
  initDownloads();
  initLpSlider();
  initLpMaterialSlider();
  initLpSurfaceSplit();
  initProductHotspots();
  initProductHotspotsEditor();
  initPricelistPreview();
  initPricelistFilesize();
  initThemeSwitch();
  initIconRowVideo();
  initInsights();
  initInsightsRelated();
  initProduktserienModal();
}